// import ORImage from "../..//images/default-or-image.jpg";

const IMAGES = {
  PRODUCTDEFAULT: "/default-or-image.jpg",
};

export default IMAGES;
